import core from './core.js';
import events from './events.js';
import util from './util.js';
import rules from './rules.js';
import impressions from './impressions.js';
import steps from './steps.js';
import checkout from './checkout.js';
import basket from './basket.js';
import accountChangeBasket from './accountChangeBasket.js';
import purchase from './purchase.js';
import promos from './promos.js';

window.gaEcommerce = {
	core: core,
	events: events,
	util: util,
	steps: steps,
	checkout: checkout,
	impressions: impressions,
	basket: basket,
	accountChangeBasket: accountChangeBasket,
	purchase: purchase,
	promos: promos,
	rules: rules
};
